import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=3d3cb960&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=3d3cb960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3cb960",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryListItem: require('/app/components/CategoryListItem.vue').default})
